module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src727013012/src/~/babel-runtime/core-js/object/assign.js
// module id = saYs
// module chunks = 6